import { Epoch } from "../types/epochs";

export const isOngoing = (period: string): boolean => {
  return period.toLowerCase().includes('present');
};

export const getEpochYears = (epoch: Epoch) => {
  return epoch.events.map(event => parseInt(event.year));
};

export const calculatePositions = (startYear: number, endYear: number, years: number[]) => {
  const totalWidth = years.length - 1;
  const startIndex = years.indexOf(startYear);
  const endIndex = years.indexOf(endYear);

  const startPosition = Number(((startIndex / totalWidth) * 100).toFixed(3)) - 0.1;
  const width = Number((((endIndex - startIndex) / totalWidth) * 100).toFixed(3)) + 0.2;

  return { startPosition, width };
}; 